import { Card } from 'antd'
import styled from 'styled-components'

export const SCard = styled(Card)`
	border: none;
	max-width: 800px;

	.ant-card-body {
		margin: 50px 0 0;
		padding: 0;
	}
`

export const Container = styled.div`
	border: 1px solid #e8e8e8;
	max-width: 800px;
	padding: 30px;
`
